import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

// Import existing winner components
import Winners from "./Winners"; // 2024 Semifinalists
import WinnersTwo from "./WinnersTwo"; // 2024 Finalists
import WinnersThree from "./WinnersThree"; // 2024 Winners
import WinnersFour from "./WinnersFour"; // 2025 Finalists
import WinnersFive from "./WinnersFive"; // 2025 Winners
import Semifinalists from "./Semifinals"; // 2025 Semifinalists
import DistinguishedScholar from "./DistinguishedScholar"; // 2025 Distinguished Scholars
import OpensResultsAndHonorRollReleased from "../components/Opens-results-and-honor-roll-released"; // 2025 Honor Roll
import FinalResults2026 from "./FinalResults2026"; // 2026 Winners
import WinnersSix from "./WinnersSix"; // 2026 Finalists
import Semifinals2026 from "./Semifinals2026"; // 2026 Semifinalists
import DistinguishedScholar2026 from "./DistinguishedScholar2026"; // 2026 Distinguished Scholars
import HonorRoll2026 from "./HonorRoll2026"; // 2026 Honor Roll
import Seo from "../components/Seo";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`winners-tabpanel-${index}`}
      aria-labelledby={`winners-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 4 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `winners-tab-${index}`,
    "aria-controls": `winners-tabpanel-${index}`,
  };
}

export default function WinnersHub() {
  const [value, setValue] = React.useState(0);

  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ minHeight: "100vh" }}>
      <Seo
        title="Winners Hub"
        path="/winners-hub"
        description="Explore the winners of the International Research Olympiad — finalists, medalists, semifinalists, distinguished scholars, and honor roll across every round and year."
      />
      {/* Hero Section */}
      <div style={{ backgroundColor: "#f8f9fa", padding: "80px 0 60px 0" }}>
        <div className="container">
          <div
            style={{ textAlign: "center", maxWidth: "800px", margin: "0 auto" }}
          >
            <h1
              style={{
                fontSize: "clamp(2.5rem, 5vw, 3.5rem)",
                fontWeight: "700",
                color: "#1a1a2e",
                marginBottom: "20px",
                letterSpacing: "-0.03em",
              }}
            >
              IRO Winners & Recognition
            </h1>
            <p
              style={{
                fontSize: "1.15rem",
                color: "#555",
                lineHeight: "1.7",
              }}
            >
              Explore the achievements of outstanding students who have excelled
              in the International Research Olympiad. Browse through winners,
              finalists, semi-finalists, and honor roll recipients from
              different years.
            </p>
            <Link
              to="/certificate"
              style={{
                display: "inline-block",
                marginTop: "28px",
                padding: "13px 26px",
                backgroundColor: "#004d99",
                color: "#fff",
                fontSize: "1rem",
                fontWeight: 600,
                borderRadius: "8px",
                textDecoration: "none",
                boxShadow: "0 4px 14px rgba(0,77,153,0.22)",
              }}
            >
              Claim your 2026 certificate →
            </Link>
          </div>
        </div>
      </div>

      {/* Tabs Section */}
      <div className="container" style={{ paddingBottom: "80px" }}>
        <Box sx={{ width: "100%", marginTop: "-30px" }}>
          {/* Tabs Navigation */}
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
              border: "1px solid #e8eef3",
              padding: "8px",
              overflowX: "auto",
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="IRO Winners tabs"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                minHeight: "48px",
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontSize: "0.95rem",
                  fontWeight: 500,
                  color: "#555",
                  minHeight: "44px",
                  padding: "10px 20px",
                  borderRadius: "8px",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "rgba(0, 77, 153, 0.04)",
                  },
                  "&.Mui-selected": {
                    color: "#004d99",
                    backgroundColor: "rgba(0, 77, 153, 0.08)",
                    fontWeight: 600,
                  },
                },
                "& .MuiTabs-indicator": {
                  display: "none",
                },
              }}
            >
              <Tab label="2026 Winners" {...a11yProps(0)} />
              <Tab label="2026 Finalists" {...a11yProps(1)} />
              <Tab label="2026 Semi-Finalists" {...a11yProps(2)} />
              <Tab label="2026 Distinguished Scholars" {...a11yProps(3)} />
              <Tab label="2026 Honor Roll" {...a11yProps(4)} />
              <Tab label="2025 Winners" {...a11yProps(5)} />
              <Tab label="2025 Finalists" {...a11yProps(6)} />
              <Tab label="2025 Semi-Finalists" {...a11yProps(7)} />
              <Tab label="2025 Distinguished Scholars" {...a11yProps(8)} />
              <Tab label="2025 Honor Roll" {...a11yProps(9)} />
              <Tab label="2024 Winners" {...a11yProps(10)} />
              <Tab label="2024 Finalists" {...a11yProps(11)} />
              <Tab label="2024 Semi-Finalists" {...a11yProps(12)} />
            </Tabs>
          </Box>

          {/* Tab Panels */}
          <CustomTabPanel value={value} index={0}>
            <FinalResults2026 />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={1}>
            <WinnersSix />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={2}>
            <Semifinals2026 />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={3}>
            <DistinguishedScholar2026 />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={4}>
            <HonorRoll2026 />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={5}>
            <WinnersFive />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={6}>
            <WinnersFour />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={7}>
            <Semifinalists />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={8}>
            <DistinguishedScholar />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={9}>
            <OpensResultsAndHonorRollReleased />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={10}>
            <WinnersThree />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={11}>
            <WinnersTwo />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={12}>
            <Winners />
          </CustomTabPanel>
        </Box>
      </div>
    </div>
  );
}
